import { Component, EventEmitter, inject, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'search-text',
  templateUrl: 'component.html',
  styleUrls: ['component.scss'],
  standalone: false,
})
export class SearchText {
  @Output() search: EventEmitter<string> = new EventEmitter<string>();

  private readonly fb = inject(FormBuilder);
  public form: FormGroup = this.fb.group({
    search: [null],
  });

  get searchControl(): FormControl | null {
    return this.form?.get('search') as FormControl | null;
  }

  get isSearchDisabled(): boolean {
    return this.searchControl?.disabled ?? false;
  }

  get searchValue(): string | null {
    return this.searchControl?.value ?? null;
  }

  public setSearch(search: string) {
    this.searchControl?.setValue(search);
    this.searchControl?.disable();
  }

  public onSubmit() {
    const search = this.searchValue;

    if (search) {
      this.searchControl?.disable();
      this.search.emit(search);
    }
  }

  public clearSearch() {
    this.searchControl?.enable();
    this.form?.reset();
    this.search.emit(null);
  }
}
